import React, { useState } from 'react';
import { CopyIcon, AwardIcon, CheckIcon } from '../../assets/imageAssets';
import Tag from "../../components/Tag";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { useAmbassadorRegisterMutation } from '../../api/mutations/ambassadors.mutation';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ambassadorRegisterSchema } from "../../schemas/schemas";
import Loader from '../../components/Loader';
import { useSelector } from 'react-redux';

const AmbassadorModal = ({modalData}) => {
    const ambassadorData = useSelector((state) => state.ambassador.data);
    const isActive = ambassadorData?.status === 'ACTIVE';

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        shouldUseNativeValidation: false,
        resolver: yupResolver(ambassadorRegisterSchema),
    });

    const { mutate, isPending } = useAmbassadorRegisterMutation();

    const [copied, setCopied] = useState(false);

    const handleCopyLink = () => {
        if (ambassadorData?.referral_link) {
            navigator.clipboard.writeText(ambassadorData.referral_link);
            setCopied(true);
            setTimeout(() => setCopied(false), 5000);
        }
    };

    return (
        <>
            <div className="modal-body">
                <img src={AwardIcon} alt="Award Icon" className="award-icon" />
                <Tag text="Ambassador Program" color="red" dot={false} />
                <h2 className='mb-8'>Share CampusAI. Earn together.</h2>
                <p className='mb-16'>Earn commission on your referrals.</p>
                {!isActive && (
                    <form className="ambassador-form flex flex-align-center mb-16" onSubmit={handleSubmit(mutate)}>
                        <Input
                            label='Write Your Unique Name'
                            placeholder='Enter your name'
                            id='slug'
                            helperText='Letters, numbers, and hyphens only · 2–32 chars'
                            register={{ ...register('slug') }}
                            error={errors?.slug}
                            errorMessage={errors?.slug?.message}
                        />
                        <Button
                            text="Submit"
                            type="outlined"
                            className="ml-8"
                        />
                    </form>
                )}
                {isActive && (
                    <>
                        <div className="referal-link-box flex flex-align-center flex-between flex-wrap mb-16">
                            <div>
                                <span>Your referral link</span>
                                <h6>{isActive ? ambassadorData.referral_link : ''}</h6>
                            </div>
                            {!copied ?
                                <Button
                                    text={"Copy Link"}
                                    icon={<img src={CopyIcon} width={20} height={20} alt="Alert" className="mr-8" />}
                                    onClick={handleCopyLink}
                                /> : 
                                <div className="copied-text flex flex-align-center">
                                    <img src={CheckIcon} width={20} height={20} alt="Alert" className="mr-8" />
                                    Link Copied
                                </div>
                            }
                        </div>
                        <div className="referal-link-info">
                            Share on social, in group chats, or add to your bio.
                        </div>
                    </>
                )}
            </div>
            {isPending && <Loader />}
        </>
    );
}

export default AmbassadorModal;